import React from "react";
import { motion } from "framer-motion";
import { Instagram, Facebook, MessageCircle, Youtube, Twitter, Users, Music2 } from "lucide-react";

const ICONS = {
    instagram_url: Instagram,
    facebook_url: Facebook,
    facebook_group_url: Users,
    whatsapp_group_url: MessageCircle,
    youtube_url: Youtube,
    twitter_url: Twitter,
    tiktok_url: Music2,
};
const LABELS = {
    instagram_url: "Instagram",
    facebook_url: "Facebook Sayfası",
    facebook_group_url: "Facebook Grubu",
    whatsapp_group_url: "WhatsApp Grubu",
    youtube_url: "YouTube",
    twitter_url: "X (Twitter)",
    tiktok_url: "TikTok",
};

export const SOCIAL_KEYS = ["instagram_url", "facebook_url", "facebook_group_url", "whatsapp_group_url", "youtube_url", "twitter_url", "tiktok_url"];

const SocialStrip = ({ settings, compact = false, title = "Bizi Sosyal Medyada Takip Edin", subtitle = "Kampanyalar, yeni otellerimiz ve mübarek anlar için sosyal kanallarımıza katılın." }) => {
    const links = SOCIAL_KEYS
        .map((k) => ({ key: k, url: (settings || {})[k] }))
        .filter((x) => x.url && String(x.url).trim().length > 4);

    if (!links.length) return null;

    if (compact) {
        return (
            <div className="flex flex-wrap gap-2" data-testid="social-strip-compact">
                {links.map(({ key, url }) => {
                    const Icon = ICONS[key];
                    return (
                        <a
                            key={key}
                            href={url}
                            target="_blank"
                            rel="noreferrer"
                            className="btn-outline-gold !text-xs !py-2 !px-3"
                            data-testid={`social-link-${key}`}
                        >
                            <Icon className="w-3.5 h-3.5" /> {LABELS[key]}
                        </a>
                    );
                })}
            </div>
        );
    }

    return (
        <section className="py-16 border-y border-border_green bg-emerald_surface" data-testid="social-strip">
            <div className="max-w-5xl mx-auto px-6 lg:px-10 text-center">
                <div className="text-xs uppercase tracking-[0.3em] text-gold mb-3">Topluluk</div>
                <h2 className="font-serif text-3xl lg:text-4xl text-balance mb-3">{title}</h2>
                <p className="text-muted_green text-sm max-w-xl mx-auto mb-8">{subtitle}</p>
                <div className="flex flex-wrap justify-center gap-3">
                    {links.map(({ key, url }) => {
                        const Icon = ICONS[key];
                        return (
                            <motion.a
                                key={key}
                                href={url}
                                target="_blank"
                                rel="noreferrer"
                                whileHover={{ y: -2 }}
                                className="border border-border_green hover:border-gold bg-emerald_deep/30 px-5 py-3 inline-flex items-center gap-2 transition-colors"
                                data-testid={`social-link-${key}`}
                            >
                                <Icon className="w-4 h-4 text-gold" />
                                <span className="text-xs uppercase tracking-[0.2em]">{LABELS[key]}</span>
                            </motion.a>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default SocialStrip;
